<div class="full-page">
  <router-outlet>
    <app-loading [general]="true" [full]="true"></app-loading>
  </router-outlet>
</div>
